// mbrs-v2-react/src/components/ForgotPassword.tsx

import React, { useState } from 'react';
import { supabase } from '../lib/supabase_client';
import { Link } from 'react-router-dom';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleResetPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMsg(null);

    try {
      // Use Supabase's built-in password reset email (with custom template)
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/Reset-Password`,
      });

      if (error) {
        // Don't reveal if email exists or not for security
        console.error('Error sending reset email:', error);
        // Still show success to prevent email enumeration
        setEmailSent(true);
        setMsg('If an account exists, a password reset link has been sent to your email.');
      } else {
        setEmailSent(true);
        setMsg('Password reset email sent! Please check your inbox.');
      }
    } catch (err: any) {
      console.error('Unexpected error:', err);
      setMsg('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white shadow-lg rounded-xl w-full max-w-md p-8">
          <div className="flex justify-center mb-6">
          <img 
            src="/images/logo-dark.png" 
            alt="Company Logo" 
            style={{ maxWidth: '200px', height: 'auto' }}
          />
        </div>
        <p className="text-center text-gray-500 mb-6">
          Enter your email address and we'll send you a link to reset your password
        </p>

        {msg && (
          <div
            className={`text-center mb-4 p-3 rounded ${
              emailSent
                ? 'bg-green-100 text-green-700'
                : 'bg-red-100 text-red-700'
            }`}
          >
            {msg}
          </div>
        )}

        {!emailSent ? (
          <form onSubmit={handleResetPassword} className="space-y-5">
            <div>
              <label className="block text-gray-700 mb-1 font-medium">Email</label>
              <input
                type="email"
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                placeholder="example@company.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2.5 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </form>
        ) : (
          <div className="text-center space-y-4">
            <p className="text-gray-600">
              We've sent a password reset link to <strong>{email}</strong>
            </p>
            <p className="text-sm text-gray-500">
              Please check your email and click the link to reset your password.
            </p>
          </div>
        )}

        <p className="text-center text-gray-500 mt-6 text-sm">
          Remember your password?{' '}
          <Link to="/signin" className="text-blue-600 hover:underline font-medium">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}